import { HStack, VStack, Pressable, Spinner } from "@gluestack-ui/themed";
import { Text } from "../Text";
import { InstallmentsInputProps } from "./types";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import { ButtonIcon } from "../Button/ButtonIcon";

export const InstallmentsInput = ({
  installments,
  maxInstallments,
  isLoadingInstallments,
  totalValue,
  onIncrement,
  onDecrement
}: InstallmentsInputProps) => {
  const isDisabledIncrement =
    installments === maxInstallments || isLoadingInstallments;
  const isDisabledDecrement = installments === 1 || isLoadingInstallments;
  return (
    <VStack gap={4}>
      <Text fontSize="$sm" fontWeight={500} family="roboto">
        Número de Parcelas*
      </Text>
      <HStack flex={1} w="$full" justifyContent="space-between">
        <VStack>
          <Text fontSize="$lg" fontWeight={500}>
            {installments} parcelas
          </Text>
          <HStack gap={4} alignItems="flex-end">
            <Text fontWeight={500}>de</Text>
            {isLoadingInstallments ? (
              <Spinner color="$secondary400" size={20} />
            ) : (
              <Text fontWeight={500} alignItems="center">
                {numberToBrl(totalValue / installments)}
              </Text>
            )}
          </HStack>
        </VStack>
        <HStack gap={12}>
          <Pressable
            h="$12"
            w="$12"
            bg={isDisabledDecrement ? "$secondary50" : "$secondary100"}
            alignItems="center"
            justifyContent="center"
            p="$3"
            borderRadius="$full"
            onPress={onDecrement}
            disabled={isDisabledDecrement}
          >
            <ButtonIcon name="minus" color="$primary500" size={20} />
          </Pressable>
          <Pressable
            h="$12"
            w="$12"
            bg={isDisabledIncrement ? "$secondary50" : "$secondary100"}
            alignItems="center"
            justifyContent="center"
            p="$3"
            borderRadius="$full"
            onPress={onIncrement}
            disabled={isDisabledIncrement}
          >
            <ButtonIcon name="plus" color="$primary500" size={20} />
          </Pressable>
        </HStack>
      </HStack>
    </VStack>
  );
};
